import { createSingleEntityStore, PickActions } from '@recruitee/ngrx';
import type { OAuthClientAuth } from '@recruitee/oauth-types';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<OAuthClientAuth[]>()('OAuthClientAuth');

const OAuthClientAuthActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  OAuthClientAuthActions,
  reducer as OAuthClientAuthReducer,
  namespace as OAuthClientAuthNamespace,
  selectors as OAuthClientAuthSelectors,
};
